<template>
  <section class="py-5 py-md-7 py-lg-8">
    <LoadingWidget v-if="loading" />

    <v-container v-else class="py-0">
      <TitleWidget v-if="title">{{ title }}</TitleWidget>

      <slot />
    </v-container>
  </section>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

export default {
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
  },
};
</script>
